import api from '@pray/shared/utils/api';

export type AdjustMarketingCampaignBudgetParams = {
  artistId: string;
  campaignId: string;
  dailyBudgetCents: number;
  adjustmentReason?: string;
};

export const adjustMarketingCampaignBudget = async ({
  artistId,
  campaignId,
  dailyBudgetCents,
  adjustmentReason,
}: AdjustMarketingCampaignBudgetParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/budget`;

  const body: Record<string, unknown> = {
    daily_budget_cents: dailyBudgetCents,
  };

  if (adjustmentReason) body.adjustment_reason = adjustmentReason;

  const response = await api.executePatchRequest(url, body);

  return response.data;
};
